import { createRoot } from "react-dom/client";
import App from "./App";
import { Analytics } from "@vercel/analytics/react"
import { StrictMode } from "react";
import "./assets/scss/main.scss";
import { Leva } from "leva";

const root = createRoot(document.getElementById("root"));

root.render(
  <>
    {/* {import.meta.env.DEV && <Leva collapsed />} */}
    <Analytics />
    <App />
  </>
);
